import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { breakpoint } from 'utils/mediaQueries';
import BlockName from 'components/pages/Qemotion/IntroBlock/BlockTextIntro/BlockName';
import BlockLifeSocial from 'components/pages/Qemotion/IntroBlock/BlockTextIntro/BlockLifeSocial';

const StyledGrid = styled(Grid)`
  ${breakpoint.down('md')`
  align-items: center;`};
`;
const TextGrid = styled(Grid)`
  height: 250px;
  ${breakpoint.down('md')`
  justify-content: center; height:auto`};
`;

const BlockTextIntro = ({ data, order }) => {
  return (
    <TextGrid
      container
      item
      xs={12}
      sm={12}
      md={12}
      lg={10}
      direction={'row'}
      alignItems="flex-start"
      justify={order === 'even' ? 'flex-end' : 'flex-start'}
    >
      <StyledGrid
        container
        direction={'column'}
        item
        xs={12}
        sm={8}
        md={12}
        lg={12}
        justify={'flex-end'}
        alignItems={order === 'even' ? 'flex-end' : 'flex-start'}
      >
        <BlockName order={order} data={data} />
        <BlockLifeSocial order={order} data={data} />
      </StyledGrid>
    </TextGrid>
  );
};
export default BlockTextIntro;
